import React from 'react';
import styled from 'styled-components'
import withReveal from 'react-reveal/withReveal';
import { Fade } from 'react-reveal';
import breakpoint from 'styled-components-breakpoint';

export const AddressContainer = withReveal(styled.article`
  background: #FFF;
  padding: ${props => props.isWhite ? '20px' : '0'};
  margin-bottom: ${props => props.grid ? '0' : '20px'};
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
  min-width: ${props => props.grid ? 'initial' : '300px'};
  
`, <Fade />);

export const Container = styled.div`
  ${breakpoint('tablet')`
    margin: ${props => props.grid ? '0' : '20px 70px 20px 20px'};
  `};
`;

export const Name = styled.p`
  margin: 5px 0;
  font-weight: 700;
`;

export const Address = styled.p`
  margin: 5px 0;
`;

export const Tel = styled.a`
  margin: 5px 0;
  display: block;
  text-transform: uppercase;
  color: #000;
  font-size: 12px;
  letter-spacing: 3px;
`;

export const Map = styled.a`
  margin: 5px 0;
  display: block;
  text-transform: uppercase;
  color: #000;
  font-size: 12px;
  letter-spacing: 3px;
`;

export const Website = styled.a`
  margin: 5px 0;
  display: block;
  text-transform: uppercase;
  color: #000;
  font-size: 12px;
  letter-spacing: 3px;
`;
